<script>
import { Line } from "vue-chartjs";

export default {
    name: "LineChart",
    extends: Line,
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },
        height: {
            type: Number,
            default: 300
        }
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    }
};
</script>
